import React, { useEffect, useContext, useState, cloneElement } from 'react';
import clsx from 'clsx';

import {
    Avatar
} from '@material-ui/core';

import Skeleton from '@material-ui/lab/Skeleton';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {},
    avatar: {
    }
}));

export const ImageSkeleton = ({ 
    empty,
    variant, 
    width, 
    height, 
    src, 
    ...props }) => {
    const classes = useStyles();

    const [isReady, setIsReady] = useState(true);
    const loadAvatarImageHandler = () => {        
        setIsReady(true);
    }

    const errorImageHandler = () => {
        setIsReady(true);
    }

    useEffect(() => {
        if(src || empty) setIsReady(false);
    }, [src])

    return (
        <div className={clsx(classes.root, props.className)}>
            {!isReady &&
                <Skeleton variant={variant} width={width} height={height} />                
            }            
            {!empty && cloneElement(props.children, { 
                src: src,
                hidden: !isReady, 
                onLoad: loadAvatarImageHandler, 
                onError: errorImageHandler,
                style: {
                    height: !isReady ? "0px" : ""
                } 
            })}
        </div>
    );
}